import React from 'react';
import AnimateHeight from 'react-animate-height';
import { BodyCopy } from '@uds/typography';
import { Colorways } from '@uds/colorway';
import Shortcode, { ShortcodeProps } from 'components/Shortcode';

import { classNames }  from './QuestionBody.stylesheet';

interface OuterProps {
  duration: number;
  colorway: Colorways;
  answer: ShortcodeProps;
  active?: boolean;
}

export const PureBody = ({ answer, colorway, duration, active }: OuterProps) => {
  const height = active ? 'auto' : 0;

  return (
    <div className={classNames.root}>
      <AnimateHeight
        height={height}
        duration={duration}
        animateOpacity={true}
        easing="ease-in-out"
        className={classNames.animateHeight}
      >
        <BodyCopy>
          <Shortcode code={answer} against={colorway} />
        </BodyCopy>
      </AnimateHeight>
    </div>
  );
};

PureBody.displayName = 'Body';

export default PureBody;
